/* eslint-disable react/jsx-pascal-case */
import React, { Component } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { Waypoint } from 'react-waypoint';

import Routes from '../Routes';
import AccordionContainer from './FooterListMobile';
import FooterList from './FooterList';
import footer from './Footer.module.scss';
import Icons from '../Icons';
import bigLogo from 'styles/images/big-logo-footer.svg';
import { MobileAndTablet, Desktop } from 'utils/responsiveQueries';
import { getStatusPageSummary } from 'redux/env/envActions';
import strings from 'lang/lang';

class FooterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      summaryStatusPage: false, 
      animateFooterLogo: false
    };
  }

  componentDidMount() {
    getStatusPageSummary().then((res) => {
      const summaryStatusPage = res.data;
      this.setState({ summaryStatusPage });
    });
  }

  handleCookies = () => {
    window.cookiehub.openSettings();
  }

  render() {
    return (
      <footer className={footer.footer}>
        <div className={footer.footer__content}>
          <div className={footer.footer__container}>
            <MobileAndTablet>
              <AccordionContainer />
            </MobileAndTablet>
            <Desktop>
              <FooterList />
            </Desktop>
            <div className={footer.footer__form_status}>
              <div className={footer.footer__status}>
                <div className={footer.footer__systems}>
                  <div className={footer.footer__label}>{strings.footerContainer.text.status}</div>
                  <div className={cn(footer.footer__btn, 'btn-footer')}>
                    <Icons.system />
                    <em>
                      {this.state.summaryStatusPage &&
                        this.state.summaryStatusPage.status.description}
                    </em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Waypoint 
          onEnter={() => {
            console.log('sdfs');
            this.setState({ animateFooterLogo: true })
          }}
          onLeave={() => this.setState({ animateFooterLogo: false })}
          topOffset="200px"
          fireOnRapidScroll={true}
          scrollableAncestor={window}
        >
          <div 
            className={cn(footer.footer__big_logo, {
              [footer['footer__big_logo--active']]: this.state.animateFooterLogo
            })}
          >
            <img src={bigLogo} alt="staq" />
          </div>
        </Waypoint>
        <div className={footer.footer__bottom}>
          <div>
            <Link to={Routes.routes.PRIVACY_POLICY.path}>{strings.footerContainer.text.privacyPolicyLink}</Link>
            <Link to={Routes.routes.TERMS.path}>{strings.footerContainer.text.termOfUseLink}</Link>
            <Link to={Routes.routes.COOKIE_POLICY.path}>{strings.footerContainer.text.CookiePolicyLink}</Link>
            <button onClick={this.handleCookies}>{strings.footerContainer.text.ManageCookieLink}</button>
          </div>
          <div className={footer.footer__license}>
            <a href="https://staq.io/resources/contact" target="_blank">{strings.footerContainer.text.license}</a>
          </div>
        </div>
      </footer>
    );
  }
}

export default FooterContainer;
